<template>
  <div>
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="container-fluid">
      <!-- ============================================================== -->
      <!-- Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <div class="row page-titles">
        <div class="col-md-5 col-8 align-self-center">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/home">Home</router-link>
            </li>
            <li class="breadcrumb-item active">スタッフ(介護の森-職員)</li>
          </ol>
        </div>
      </div>
      <!-- ============================================================== -->
      <!-- End Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <div class="row">
        <div class="col-12">
          <!-- Column -->
          <div class="card">
            <div class="card-body">
              <div class="">
                <div class="row">
                  <div class="col-4">
                    <div class="form-group" :class="{'has-danger': errors.office_id }">
                      <label class="control-label">事業所</label>
                      <select-office
                        v-model="inputs.office_id"
                        name="office_id"
                      />
                      <!-- <div class="text-danger" v-if="errors.office_id">{{ errors.office_id }}</div> -->
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-8">
                    <div class="form-group" :class="{'has-danger': errors.file }">
                      <label class="control-label">ファイル</label>
                      <input
                        type="file"
                        class="form-control"
                        accept=".csv"
                        @change="onFileChange"
                      />
                      <!-- <div class="text-danger" v-if="errors.file">{{ errors.file }}</div> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-actions">
                <div class="row">
                  <div class="col-md-12 text-center">
                    <button
                      type="button"
                      class="action-button btn btn-success btn-rounded"
                      @click="save"
                      :disabled="isProcessing"
                    >
                      インポート
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Column -->
        </div>
      </div>
      <div class="row" v-if="Object.keys(errors).length > 0">
        <div class="col-md-12">
          <div class="alert alert-warning">
            <button type="button" class="close" @click="errorsClear" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <ul>
              <li v-for="(error, field) in errors" :key="field">
                {{ error }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import api from '../../libs/Api'
import SelectOffice from '../../components/SelectOffice'
import * as yup from 'yup'
import { useExecutor } from '@/libs/Executor'
import { useToast } from 'vue-toastification'

const { exec } = useExecutor()

// Setup toast
const toast = useToast()

// State
const inputs = ref({
  file: null,
  office_id: null
})
const isProcessing = ref(false)
const errors = ref({})

// Validation schema
const validationSchema = yup.object({
  office_id: yup.string().required('事業所を入力してください。'),
  file: yup.mixed().required('ファイルを入力してください。')
})

// const validateField = async (fieldName) => {
//   exec(async () => {
//     await validationSchema.validateAt(fieldName, inputs.value)
//     delete errors.value[fieldName]
//   }).catch(err => {
//     errors.value[fieldName] = err.message
//   })
// }

const validateForm = async () => {
  try {
    await validationSchema.validate(inputs.value, { abortEarly: false })
    errors.value = {}
    return true
  } catch (err) {
    const newErrors = {}
    err.inner.forEach(err => {
      newErrors[err.path] = err.message
    })
    errors.value = newErrors
    return false
  }
}

const onFileChange = (e) => {
  const files = e.target.files || e.dataTransfer.files
  if (files && files.length > 0) {
    inputs.value.file = files[0]
  } else {
    inputs.value.file = null
  }
}

const errorsClear = () => {
  errors.value = {}
}

const save = async () => {
  exec(async () => {
    const isValid = await validateForm()
    if (!isValid) return

    isProcessing.value = true
    const result = await api.importKaigoNoMoriStaff(inputs.value)

    if (result) {
      toast.success('インポートに成功しました。')
      if (result.length > 0) {
        result.forEach((error, index) => {
          errors.value[`line_${index + 1}`] = error
        })
        errors.value.file = '上記の行数が取り込めませんでした。'
      }
    }
  }).catch(err => {
    console.error('Error importing staff:', err)
    toast.error('インポートに失敗しました。')
  }).finally(() => {
    isProcessing.value = false
  })
}
</script>

<style lang="scss" scoped>
.data-actions {
  text-align: right;
}

.table th {
  background-color: #99abb4 !important;
}

.has-danger {
  .form-control {
    border-color: #dc3545;
  }

  .text-danger {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.875em;
  }
}

.action-button {
  &:disabled {
    cursor: not-allowed;
    opacity: 0.65;
  }
}
</style>
